module.exports = __webpack_public_path__ + "img/thumbmad2.63c5b231.png";